const Main = () => import('@pages/main/Main')
const Service = () => import('@pages/main/tabs/Service')
const User = () => import('@pages/main/tabs/User')

export const main = [
  {
    path: '/',
    redirect: '/home',
    component: Main,
    meta: {},
    children: [
      {
        path: '/home',
        name: 'Service',
        component: Service,
        meta: {}
      },
      {
        path: '/user',
        name: 'User',
        component: User,
        meta: {}
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/main.route.js